// extracted by mini-css-extract-plugin
export default {"productGallery":"XM-z","inQuickShop":"YM-z"};